import {
  LinkCategory,
  LinkLabelCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import { ModelConceptHierarchyLabel } from 'src/containers/ProjectDiagram/types/data';
import { getModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { RDFS_SUB_CLASS_OF_IRI } from 'src/templates/queries/iris';

export const getModelConceptHierarchyLabelKey = ({
  fromIri,
  value = RDFS_SUB_CLASS_OF_IRI,
  toIri,
}: {
  fromIri: string;
  toIri: string;
  value?: string;
}) =>
  `${LinkLabelCategory.MODEL_CONCEPT_HIERARCHY_LABEL}-${fromIri}-${value}-${toIri}`;

export const getLabelKeyFromHierarchyKey = (linkKey: string) =>
  linkKey.replace(
    new RegExp(`^${LinkCategory.MODEL_CONCEPT_HIERARCHY}`),
    LinkLabelCategory.MODEL_CONCEPT_HIERARCHY_LABEL
  );

export const createModelConceptHierarchyLabel = ({
  fromIri,
  value = RDFS_SUB_CLASS_OF_IRI,
  toIri,
}: {
  fromIri: string;
  toIri: string;
  value?: string;
}): ModelConceptHierarchyLabel => ({
  key: getModelConceptHierarchyLabelKey({ fromIri, value, toIri }),
  from: getModelConceptClassKey(fromIri),
  value,
  to: getModelConceptClassKey(toIri),
  category: LinkLabelCategory.MODEL_CONCEPT_HIERARCHY_LABEL,
});
